import { useParams } from "react-router-dom";
import { Authenticated, useOne, useTranslate } from "@refinedev/core";
import { Typography, Spin, Form, Flex, Switch } from "antd";
import { SubPageHeader } from "../../../components/SubPageHeader";
import { MediaProjectResponse } from "../types";
import { useProjectInstance } from "./hooks/useProjectInstance";
import { useEffect } from "react";

const EditChatForm = ({
  projectId,
  instanceId,
}: {
  projectId: string;
  instanceId: string;
}) => {
  const [form] = Form.useForm();
  const t = useTranslate();
  const { updateSettings, instanceSettings, isLoading, isMutating } =
    useProjectInstance({
      projectId,
      instanceId,
    });
  const formProps = {
    form,
    // onFinish: async (values: any) => {},
  };
  const isChatEnabled = instanceSettings.chat_mode !== "Disabled";

  const handleChange = (value) => {
    const chat_mode = value ? "FullChat" : "SourcesOnly";
    void updateSettings({ chat_mode });
  };
  useEffect(() => {
    form.setFieldValue(
      "enable_chat_answers",
      instanceSettings.chat_mode === "FullChat"
    );
  }, [instanceSettings, form]);

  return (
    <Form {...formProps}>
      <label htmlFor="enable_chat_answers">
        <Flex vertical>
          <Typography.Text strong>
            {t("projects.components.ProjectChat.displayAiAnswers")}
          </Typography.Text>
          <Typography.Text type="secondary">
            {t("projects.components.ProjectChat.useTheLibertify")}
          </Typography.Text>
        </Flex>
      </label>
      {!isLoading && (
        <Form.Item name="enable_chat_answers" valuePropName="checked">
          <Switch
            disabled={!isChatEnabled || isMutating}
            onChange={handleChange}
          />
        </Form.Item>
      )}
    </Form>
  );
};
export const EditChat = () => {
  const params = useParams();
  const { id: projectId, instanceId } = params;
  const { data, isLoading } = useOne<MediaProjectResponse>({
    resource: `media/projects`,
    id: projectId,
  });
  const project = data?.data;

  if (isLoading) {
    return <Spin fullscreen />;
  }

  return (
    <Authenticated key="project_editChat">
      <SubPageHeader
        itemId={project.id}
        itemTitle={project.title}
        page="editChatBot"
        source="projects"
        spaced
      />
      <EditChatForm projectId={projectId} instanceId={instanceId} />
    </Authenticated>
  );
};
